module.exports = __webpack_public_path__ + "img/like-heart-white.dae7ae38.svg";